export default "__VITE_PUBLIC_ASSET__873e76ec__"